import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name : "DataSIgnalSiteSummaryPopup",
    props: {
        data: [],
        heading: String,
    },
    components: {
        customModal,
    },
    data(){
        return {
        head:{},
        idToken:"",
        baseUrl: process.env.VUE_APP_Service_URL,
        studyId: "",
        defaultdate: "",
        };
    },
    computed: {
        flattenedData() {
            return this.data.flatMap(site =>
            site.criticalDataSignal.map(signal => ({
                siteCode: site.siteCode,
                runDate: site.runDate,
                flagType: signal.flagType,
                fieldNames: signal.flagTypes
                .flatMap(ft => ft.fieldName)
                .join(", "),
            }))
            );
        },
    },
    async mounted() {
        console.log("data in site summary popup", this.data);
            this.idToken = store.getters.getIdToken;
            this.defaultdate = localStorage.getItem("dateformat");
    },
    methods: {  
        closeModal() {
            this.$emit("closeCriticalSites");
        },
        filter(date) {
          if (date) {
            return moment(date).format(this.defaultdate)
          }
        },
    }

};